module.exports = __webpack_public_path__ + "img/AI (1).a99568ec.png";